import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles';
import { Link } from '@bd/bdcore-named-routes';
import { userLogout } from '@bd/bdcore-data/build/User/actions';
import FavoritesCategories from '../components/Favorites';
import PageMenu from '../components/PageMenu';
import { colors } from '../styles';

const styles = css`
  .ClientProduct_product {
    background-color: ${colors.brand2};
    padding: 20px;
  }

  .ClientProduct_productTitle {
    text-align: center;
    color: ${colors.brand2Text};
    font-weight: 700;
  }
`;

export const products = [
  {
    param: 'favorites',
    title: 'My Favorites',
    icon: '/images/icon-my-favorites.svg',
    isProductEnabled: builder => get(builder, 'products.BDWebsiteFavorites.isPurchased'),
    component: FavoritesCategories,
  },
];

function ClientDashboard({ builder, dispatch, product, user }) {
  const enabledProducts = products.filter(menuProduct => (
    (menuProduct.isProductEnabled || (() => false))(builder, user)
  ));
  const activeProduct = enabledProducts.find(menuProduct => menuProduct.param === product);
  return (
    <div className={styles}>
      <PageMenu
        title="Account Menu"
        items={[
          {
            title: `Welcome, ${user.firstName}`,
            name: 'my-account',
          },
          ...enabledProducts.map(menuProduct => ({
            name: 'my-account',
            params: { product: menuProduct.param },
            title: menuProduct.title,
          })),
          {
            onClick: () => dispatch(userLogout()),
            title: 'Logout',
          },
        ]}
      />
      {
        !activeProduct &&
        <div className="container mt-5 pt-5">
          <div className="row">
            {
              enabledProducts.map(menuProduct => (
                <div className="col-2">
                  <Link name="my-account" params={{ product: get(menuProduct, 'param') }}>
                    <div className="ClientProduct_product">
                      {
                        get(menuProduct, 'icon') &&
                        <div className="ClientProduct_productIcon">
                          <img src={get(menuProduct, 'icon')} alt={get(menuProduct, 'title')} />
                        </div>
                      }
                      <div className="ClientProduct_productTitle">{get(menuProduct, 'title')}</div>
                    </div>
                  </Link>
                </div>
              ))
            }
          </div>
        </div>
      }

      {
        activeProduct &&
        <activeProduct.component user={user} builder={builder} />
      }
    </div>
  );
}

ClientDashboard.propTypes = {
  builder: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object,
  product: PropTypes.string,
};

ClientDashboard.defaultProps = {
  user: undefined,
  product: undefined,
};

export default withData()(ClientDashboard);



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/ClientDashboard.js